module.exports = __webpack_public_path__ + "static/media/ios-volume-high.2dc2b656.svg";